import { useAtomValue } from 'jotai';
import { commentAtomFamily } from '../comments';

export const useComment = (commentId: string) => {
    const comment = useAtomValue(commentAtomFamily(commentId));
    return comment;
};
